module.exports = __webpack_public_path__ + "img/kuraray_PPT1_CN.b4cf0067.jpg";